import Reflux from 'reflux';
import EventFileSystemObjectData from 'shared/data/EventFileSystemObject';

let async = { asyncResult: true },
  EventFolderEditFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    submitField: {},
    save: async,
    populate: {},
  });

EventFolderEditFormActions.save.listenAndPromise(
  EventFileSystemObjectData.updateFolder,
);

export default EventFolderEditFormActions;
